import { HttpClient } from "@angular/common/http"; 
import { inject, Injectable } from "@angular/core"; 
import { HospitalInvoiceDetailCreateRequestDTO, HospitalInvoiceDetailDeleteRequestDTO, HospitalInvoiceDetailDTO, HospitalInvoiceDetailList, HospitalInvoiceDetailReadByIdRequestDTO, HospitalInvoiceDetailReadByInvoiceIdRequestDTO,  HospitalInvoiceDetailUpdateRequestDTO, InvoiceDetailCreateBulkRequestDTO } from "./invoice-detail.interface"; 
import { Observable } from "rxjs"; 
import { HospitalInvoiceDetail_Create, HospitalInvoiceDetail_CreateBulk, HospitalInvoiceDetail_Delete, HospitalInvoiceDetail_ReadAll, HospitalInvoiceDetail_ReadById, HospitalInvoiceDetail_ReadByInvoiceId, HospitalInvoiceDetail_ReadByPatientId, HospitalInvoiceDetail_ReadByServiceId, HosptialInvoiceDetail_Update } from "src/app/GlobalVariable/Hospital.GlobalVariable"; 

@Injectable({ 
    providedIn: 'root' 
}) 

export class HospitalInvoiceDetailService { 
    constructor() {}; 

    http = inject(HttpClient); 

    HospitalInvoiceDetail_Create(data: HospitalInvoiceDetailCreateRequestDTO): Observable<HospitalInvoiceDetailDTO> { 
        return this.http.post<HospitalInvoiceDetailDTO>(HospitalInvoiceDetail_Create, data); 
    }; 

    HospitalInvoiceDetail_Update(data: HospitalInvoiceDetailUpdateRequestDTO) : Observable<HospitalInvoiceDetailDTO> { 
        return this.http.post<HospitalInvoiceDetailDTO>(HosptialInvoiceDetail_Update, data); 
    }; 

    HospitalInvoiceDetail_ReadAll(): Observable<void>{ 
        return this.http.get<void>(HospitalInvoiceDetail_ReadAll); 
    }; 

    HospitalInvoideDetail_ReadById(data: HospitalInvoiceDetailReadByIdRequestDTO): Observable<HospitalInvoiceDetailDTO> { 
        return this.http.post<HospitalInvoiceDetailDTO>(HospitalInvoiceDetail_ReadById, data); 
    }; 

    HospitalInvoiceDetail_ReadByInvoiceId(data: HospitalInvoiceDetailReadByInvoiceIdRequestDTO) : Observable<HospitalInvoiceDetailList> { 
        return this.http.post<HospitalInvoiceDetailList>(HospitalInvoiceDetail_ReadByInvoiceId, data); 
    }; 

    // HospitalInvoiceDetail_ReadByPatientId(data: HospitalInvoiceDetailReadByUserIdRequestDTO) : Observable<HospitalInvoiceDetailList> { 
    //     return this.http.post<HospitalInvoiceDetailList>(HospitalInvoiceDetail_ReadByPatientId, data); 
    // }; 

    HospitalInvoiceDetail_Delete(data: HospitalInvoiceDetailDeleteRequestDTO) : Observable<void> { 
        return this.http.post<void>(HospitalInvoiceDetail_Delete, data); 
    }; 

    HospitalInvoiceDetail_CreateBulk(data:InvoiceDetailCreateBulkRequestDTO) : Observable<HospitalInvoiceDetailList>{ 
        return this.http.post<HospitalInvoiceDetailList>(HospitalInvoiceDetail_CreateBulk,data) 
    } 

} 
